import { HttpClient, HttpEventType } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ClientBaseApiService } from 'src/app/core/api/client-base-api.service';
import { HttpRequestTypes } from 'src/app/core/models/enums/http-request-types';
import { LoadingService } from 'src/app/core/services/loading.service';
import { ShareService } from 'src/app/core/services/share.service';
import { Image } from '../models/pesttrapp-home-page-response';

@Injectable({
  providedIn: 'root'
})
export class ImageToolsService {
  categoriesList: Array<any> = [];
  downloadProgress: number;
  constructor(private clientProxy: ClientBaseApiService,
    private http: HttpClient, private shareService: ShareService, private loadingService: LoadingService) {
    this.categories()
  }


  drawAnnnotions(image: Image): Observable<Image> {
    return new Observable(observer => {
      this.clientProxy.externalApiCall({ url: image.JsonUrl, payload: {}, requestType: HttpRequestTypes.GET }).subscribe(e => {
        image["height"] = e.images[0].height;
        image["width"] = e.images[0].width;
        image["svgList"] = [];
        e.annotations.forEach(element => {
          let color = "";
          for (let i = 0; i < element.M_BBOX.length; i++) {
            if (i % 2 == 0) {
              element.M_BBOX[i] = element.M_BBOX[i] * image.actualImageSize.width / image["width"]
            } else {
              element.M_BBOX[i] = element.M_BBOX[i] * image.actualImageSize.height / image["height"]
            }
            color = this.categoriesList.find(e => e.ClassId == element.category_id) ? this.categoriesList.find(e => e.ClassId == element.category_id)["ColorCode"] : "#000000";
          }
          image["svgList"].push(
            {
              BBOX: element.M_BBOX.join(","),
              color: color
            });
        });
        observer.next(image);

      });
    });


  }

  changeImage(item: any, elementId: string) {
    this.loadingService.showLoading();
    let that = this;
    let img = document.getElementById(elementId);
    let imageUrl = item.ImageUrl.split('?')?.[0];
    if (!imageUrl) {
      imageUrl = item.ImageUrl
    }
    let selectedImgUrl = img?.getAttribute('src')!.split('?')?.[0];
    if (!selectedImgUrl) {
      selectedImgUrl = img?.getAttribute('src')!
    }
    if (imageUrl == selectedImgUrl) {
      if (!img) {
        img = document.getElementById(elementId);
      }
      img?.setAttribute('src', item.ProcessPhotoUrl);
      img!.onload = function () {
        that.loadingService.hideLoading();
      };
      img!.onerror = function () {
        img?.setAttribute('src', "");
        that.loadingService.hideLoading();
      }
    } else {
      if (!img) {
        img = document.getElementById(elementId);
      }
      img!.setAttribute('src', item.ImageUrl);
      img!.onload = function () {
        that.loadingService.hideLoading();
      };
      img!.onerror = function () {
        that.loadingService.hideLoading();
      }
    }
  }
  categories() {
    let url = "https://doktarbase.blob.core.windows.net/legacy/lang/pesttrap/categories/category.json?v=" + Math.random();
    this.clientProxy.externalApiCall<any>({ url, payload: {}, requestType: HttpRequestTypes.GET }).subscribe(e => {
      return this.categoriesList = e.category;
    })
  }


  shareImage(id: string) {
    let img = document.getElementById(id);
    let selectedImgUrl = img.getAttribute('src');
    let array = [];
    array.push(selectedImgUrl);
    this.shareMultiple(array).subscribe(e => {
    });
  }


  convertBlobToBase64(blob: Blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader;
      reader.onerror = reject;
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.readAsDataURL(blob);
    });
  }


  shareMultiple(list: Array<string>) {
    return this.shareService.shareMultipleImage(list);
  }
}
